import { useEffect, useState } from "react";
import { selectedOptic, userData } from "../js/utils";
import { post } from "../js/post";

export function useOptometrists() {
  const [list, setList] = useState([]);

  async function getData() {
    const response = await post("ListarOptometristas.php", {
      token: userData.token,
      optica: selectedOptic.id,
    });
    setList(response.map((e) => ({ id: e, text: e })));
  }

  useEffect(() => {
    getData();
  }, []);

  return list;
}
